import CONFIG from 'Config/settings';
import Auth0Client from './auth0/Auth0Client';
import CIAMApiClient from './ciam/CIAMApiClient';
import CIAMApiClientMock from './ciam/CIAMApiClientMock';
import CMSProfileApiClient from './profile/CMSProfileApiClient';
import IRWProfileApiClientV2Mock from './profile/IRWProfileApiClientV2Mock';
import IRWAuthenticationApiClient from './auth/IRWAuthenticationApiClient';
import StoresApiClient from './stores/StoresApiClient';
import ShoppingApiClient from './commerce/ShoppingApiClient';
import OWShoppingListApiClient from './commerce/OWShoppingListApiClient';
import OWShoppingListApiClientMock from './commerce/OWShoppingListApiClientMock';
import { AddressApiClients } from './address';
import PaymentsApiClient from './payment/PaymentsApiClient';
import PaymentsApiClientMock from './payment/PaymentsApiClientMock';
import SalutationApiClient from './salutation/SalutationApiClient';
import ProfanityFilterApiClient from './profanityFilter/ProfanityFilterApiClient';

const storesClient = new StoresApiClient();

export const ProfileService = CONFIG.USE_MOCKS
  ? new IRWProfileApiClientV2Mock()
  : new CMSProfileApiClient();

export const AuthService = new IRWAuthenticationApiClient();

export const Auth0Service = Auth0Client;

export const CIAMService = CONFIG.USE_MOCKS
  ? new CIAMApiClientMock()
  : new CIAMApiClient();

export const StoresService = storesClient;

export const ShoppingService = CONFIG.FEATURE.ENABLE_NEW_SHOPPING_LIST_API
  ? CONFIG.USE_MOCKS
    ? new OWShoppingListApiClientMock()
    : new OWShoppingListApiClient()
  : new ShoppingApiClient();

export const AddressAutocompleteService =
  AddressApiClients[CONFIG.ADDRESS_AUTOCOMPLETE.SERVICE_PROVIDER] &&
  new AddressApiClients[CONFIG.ADDRESS_AUTOCOMPLETE.SERVICE_PROVIDER]();

export const PaymentsService = CONFIG.USE_MOCKS
  ? new PaymentsApiClientMock()
  : new PaymentsApiClient();

export const SalutationService = new SalutationApiClient();

export const ProfanityFilterService = new ProfanityFilterApiClient();
